export default "__VITE_ASSET__mHJ4Evft__"